export default __webpack_public_path__ + "static/media/Monk's Helm of the Abyss.9daa0f1e.jpg";